import {
  Button,
  FlexBox,
  JoonUIColor,
  Modal,
  ModalHeader,
  SPACING,
  TextButton,
  Typography,
} from "@joonapp/web-shared"

import useSessionLateCancelModalStore from "./hooks/useSessionLateCancelModalStore"
import { useUpdateSessionBookingMutation } from "../../../networking/sessions/mutations"
import { useSessionBookingsQuery } from "../../../networking/sessions/queries"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"

const SessionLateCancelModal = () => {
  const { isOpen, onClose, sessionBookingId } = useSessionLateCancelModalStore()
  const { data: sessionBookings } = useSessionBookingsQuery()
  const sessionBooking = sessionBookings?.find(
    (booking) => booking.id === sessionBookingId
  )

  const updateSessionBookingMutation = useUpdateSessionBookingMutation()

  const handleConfirm = async () => {
    if (!sessionBookingId) return
    await updateSessionBookingMutation.mutateAsync({
      sessionBookingId,
      markLateCancel: true,
    })
    onClose()
    trackAnalyticEvent(ANALYTIC_EVENTS.MARK_SESSION_AS_LATE_CANCEL, {
      auto_scheduled: sessionBooking?.auto_scheduled,
    })
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      animate
      style={{ width: "min(500px, 100vw)" }}
    >
      <ModalHeader
        onClose={onClose}
        title="Mark as late cancellation"
        showBorderBottom
      />
      <FlexBox
        direction="column"
        gap={SPACING.space6}
        style={{
          padding: SPACING.space6,
          paddingTop: SPACING.space4,
        }}
      >
        <FlexBox direction="column" gap={SPACING.space2}>
          <Typography variant="body">
            Only do this when your client cancelled/rescheduled within 24 hours
            of the session.
          </Typography>
          <Typography variant="body">
            By default, the client will lose this session and will have to use
            one of their other available slots to reschedule. This action is
            non-reversible.
          </Typography>
        </FlexBox>

        <FlexBox
          direction="row"
          gap={SPACING.space2}
          align="center"
          justify="flex-end"
        >
          <TextButton onClick={onClose}>
            <Typography
              variant="bodyBold"
              color={JoonUIColor.text.primaryAccent}
            >
              Cancel
            </Typography>
          </TextButton>
          <Button
            text="Confirm"
            onClick={handleConfirm}
            isLoading={updateSessionBookingMutation.isLoading}
          />
        </FlexBox>
      </FlexBox>
    </Modal>
  )
}

export default SessionLateCancelModal
